import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { CoreServiceService } from 'src/app/services/core/core-service.service';
import { MessageService } from 'src/app/services/message/message.service';
import { environment } from 'src/environments/environment';
import {
    trigger,
    state,
    style,
    animate,
    transition,
} from '@angular/animations';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { DialogVideo } from 'src/app/pages/home/home.component';
import { Subscription } from 'rxjs';
import { ProfileComponent } from 'src/app/pages/profile/profile.component';
import { NavigationEnd, Router } from '@angular/router';
import { DashboardDialogComponent, InvitationDialogComponent } from '../dashboard-menu/dashboard-menu.component';
import { v4 as uuidv4 } from 'uuid';
import { filter } from 'rxjs/operators';
/** @title Responsive sidenav */
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    animations: [
        trigger('hamburguerX', [
            state('hamburguer', style({})),
            state('topX', style({
                transform: 'rotate(45deg)',
                transformOrigin: 'left',
                margin: '6px',
                position: 'relative',
                top: '-5px'
            })),
            state('hide', style({
                opacity: 0
            })),
            state('bottomX', style({
                transform: 'rotate(-45deg)',
                transformOrigin: 'left',
                margin: '6px',
                width: '30px'
            })),
            transition('* => *', [
                animate('0.2s')
            ]),
        ]),
    ],
})
export class HeaderComponent implements OnInit, AfterViewInit {
    isHamburguer = true;
    userData : any;
    currentUser: any;
    lang = 'fr';
    isOpenMenu = false;
    loggedIn = this.authService.logIn;
    startLoad = true;
    name: string;
    profile: string;
    commonRef: string;
    inviteBadge = 0;
    userManager = false;
    userEmail = '';
    hideNav = localStorage.getItem('hideNav') && localStorage.getItem('hideNav') !== "0" ? 1 : 0;
    idonglet = null;
    isProjectVisible: boolean = false;
    allNotif: 0;
    mode: 'collaboratif' | 'cooperatif' = 'collaboratif';
    showInfo = false;
    @ViewChild('popupInfo', {static: false}) popupInfo!: ElementRef;
    isSelected = "homes";
    // Propriétés à ajouter
    profileMenuOpen = false;
    activeProfile: any = null; // le profil actuellement affiché (par défaut = currentUser)
    contacts = [];
    allcontacts: any[] = [];
    copiedContactId: any = null;
    
    vibrantColors = [
      "#FF5733", // Rouge vif
      "#FF8D1A", // Orange vif
      "#F9C74F", // Jaune doré
      "#4CAF50", // Vert
      "#D32F2F", // Rouge profond
      "#9C27B0", // Violet
      "#E91E63", // Rose
      "#FFEB3B", // Jaune
      "#00BCD4", // Bleu clair
      "#8BC34A", // Vert lime
      "#FF5722", // Orange foncé
      "#3F51B5", // Bleu indigo
      "#9E9D24", // Jaune-vert
      "#F44336", // Rouge éclatant
      "#00C853", // Vert vif
      "#9E1B32", // Rouge sombre
      "#F50057", // Rose fuchsia
      "#FF7043", // Orange corail
      "#8E24AA", // Violet intense
      "#388E3C"  // Vert forêt
    ];

    constructor(private translate: TranslateService,
        private messageService: MessageService,
        public authService: AuthService,
        public cdr: ChangeDetectorRef,
        public dialog: MatDialog,
        private router: Router,
        private coreService: CoreServiceService) {
          this.router.events
          .pipe(filter(event => event instanceof NavigationEnd))
          .subscribe(() => {
            this.checkUrl();
          });

        this.checkUrl();
    }

    @HostListener('document:click', ['$event'])
    clickOutside(event: Event): void {
      if (
        this.showInfo &&
        this.popupInfo &&
        !this.popupInfo.nativeElement.contains(event.target)
      ) {
        this.showInfo = false;
      }
    }

    loadContact() {
      this.authService.getUserCompagnyMember(this.authService.currentUser['compId']).subscribe(res => {
        this.contacts = res['hydra:member'];
        this.contacts.sort((a, b) => {
          /*if (a.isCreator !== b.isCreator) {
            return a.isCreator ? -1 : 1;
          }
          const aIsCurrentUser = a.user && a.user.id === this.authService.currentUser.id;
          const bIsCurrentUser = b.user && b.user.id === this.authService.currentUser.id;

          if (aIsCurrentUser !== bIsCurrentUser) {
            return aIsCurrentUser ? -1 : 1;
          }
          if (a.isAdmin !== b.isAdmin) {
            return a.isAdmin ? -1 : 1;
          }
          if (!!a.user !== !!b.user) {
            return a.user ? -1 : 1;
          }*/
         if (a.isCreator !== b.isCreator) {
            return a.isCreator ? -1 : 1;
          }

          // 2. Ensuite les admins
          if (a.isAdmin !== b.isAdmin) {
            return a.isAdmin ? -1 : 1;
          }
          return this.getContactName(a).localeCompare(this.getContactName(b));
        });
        this.contacts.forEach(contact => {
          contact.user.color = this.getRandomColor();
        });
        this.allcontacts = this.contacts;
        this.initActiveProfile();
        //this.loadContactNotRegister();
      },
        err => {
          const error = err.error;
          const errorS = error.message;
          const errorD = error.detail;
          const errorH = error['hydra:description'];
          if (errorS === 'Bad credentials') {
             alert(errorS);
          } else if (errorD === "L'utilisateur n'est pas encore activé. pour l'activer, vous devez cliquer sur le lien de confirmation du mail que vous avez reçu") {
            alert(errorD);
          } else if (errorH) {
            alert(errorH);
          }
        });
    }

    getContactName(contact: any): string {
      if (contact && contact.user && contact.user.fullName) {
        return contact.user.fullName.toLowerCase();
      }

      if (contact && contact.email) {
        return contact.email.toLowerCase();
      }

      return '';
    }

    getRandomColor(): string {
      const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
      return this.vibrantColors[randomIndex];
    }

    // À appeler une fois que this.contacts est chargé (à la fin de loadContact() par exemple)
    initActiveProfile() {
      this.activeProfile = this.contacts.find(c => c.user && c.user.id === this.authService.currentUser.id);
      this.cdr.detectChanges();
    }

    toggleProfileMenu() {
      this.profileMenuOpen = !this.profileMenuOpen;
    }

    copyInvitationLink(contact: any, userPosition = 0, event: MouseEvent): void {
      event.stopPropagation();

      const token = localStorage.getItem("externalToken")

      if (!token) {
        console.error('Token introuvable');
        return;
      }

      const invitationLink =
        `${environment.app_url}open?token=${token}&user=${userPosition}`;

      navigator.clipboard.writeText(invitationLink).then(() => {

        // Afficher "Copié !"
        this.copiedContactId = contact.id;

        // Revenir à l'icône copier après 2 secondes
        setTimeout(() => {
          this.copiedContactId = null;
        }, 2000);

      }).catch(error => {
        console.error('Impossible de copier le lien', error);
      });
    }


    selectProfile(contact: any) {
      if (contact.user.id === this.authService.currentUser.id) {
        this.profileMenuOpen = false;
        return; // déjà sur ce profil
      }

      this.authService.switchProfile(contact.user.id).subscribe(
        resp => {
          // Stocke le nouveau token (adapte au nom de clé que ton AuthService utilise déjà)
          localStorage.setItem('token', resp['token']);
          if (resp) {
                localStorage.setItem('currentUser', JSON.stringify(resp));
                localStorage.setItem('lang_site', 'fr');
                localStorage.setItem('lang_discuss', 'fr');
                localStorage.setItem('notifDiscussion', "2");
                localStorage.setItem('notifReport', "1");
                localStorage.setItem('notified', "all");
                localStorage.setItem('notifAtions', "1");
                localStorage.setItem('notifMode', "100");
                localStorage.setItem('notifprojectMode', "100");
                localStorage.setItem('notifModeAction', "100");
                localStorage.setItem('notifModeReunion', "100");
                localStorage.setItem('hideNav', '0');
                this.authService.currentUser = JSON.parse(localStorage.getItem('currentUser'));
                this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
                var secteur  = this.currentUser.comType;
                localStorage.setItem('firstConnection', resp['firstConnection']);
                var langapp  = this.currentUser.langapp;
                var langmsg  = this.currentUser.langmsg;
                var translate  = this.currentUser.translate;
                if(langapp && langapp != "") {
                  localStorage.setItem('lang_site', langapp);
                } 
                if(langmsg && langmsg != "") {
                  localStorage.setItem('lang_discuss', langmsg);
                } 
                localStorage.setItem('translate', translate);
                if(secteur === "Réseaux de Magasins"){
                  secteur = "magasins";
                } else if(secteur === "Réseaux de Clients"){
                  secteur = "clients";
                } else {
                  secteur = "groupes";
                }
                localStorage.setItem('secteur', secteur);
                this.router.navigate(['/dashboard']);
                this.messageService.setShowCreateProjectTuto(true);
                //this.messageService.setSound(resp['sound']);
                this.messageService.setSound(resp['sound']);
                this.messageService.setShowProjectTuto(true);
                this.messageService.setShowProjectTutobis(true);
                this.messageService.setShowNotifTuto(true);
                this.initActiveProfile();
                console.log("curretn user : "+this.currentUser.id)
                window.location.reload();
              }

          // Recharge complètement l'app pour repartir avec le bon contexte utilisateur
        },
        err => {
          alert('Impossible de basculer vers ce profil');
        }
      );
    }

    getInitials(contact: any): string {
      if (!contact || !contact.user) return '';
      const given = contact.user.givenName || '';
      const family = contact.user.familyName || '';
      return (given.charAt(0) + family.charAt(0)).toUpperCase();
    }

    getRoleLabel(contact: any): string {
      if (contact.isCreator) return 'Admin';
      if (contact.isAdmin) return 'Co-Admin';
      return 'Collaborateur';
    }

    toggleInfo() {
      this.showInfo = !this.showInfo;
    }

    onMouseEnter(): void {
      console.log("enter")
      this.showInfo = true;
    }

    onMouseLeave(): void {
      console.log("leave")
      this.showInfo = false;
    }

    setMode(value: 'collaboratif' | 'cooperatif') {
      this.mode = value;
    }

    checkUrl() {
      this.isProjectVisible = !this.router.url.includes('project') && !this.router.url.includes('homes') && !this.router.url.includes('entreppayment') && !this.router.url.includes('storage') && !this.router.url.includes('statistique');
    }

    onChosenProject(IdProjectChosen) {
      /*this.GED = false;
      this.ID = IdProjectChosen;
      if (this.appged) {
        this.appged.reset();
      }
      if (this.singleproject) {
        this.singleproject.projecthasChange(IdProjectChosen);
      }*/
      this.messageService.setChosenProject(IdProjectChosen);
    }
  
    onProjectChanged(libelle) {
      this.messageService.setLibelleProject(libelle);
      /*if (this.singleproject) {
        this.singleproject.projectlibChanged(libelle);
      }*/
    }
  
    onNotificationsChanged(total) {
      console.log("toooot "+total)
      this.messageService.setNotifProject(total);
      /*if (this.singleproject) {
        this.singleproject.projectlibChanged(libelle);
      }*/
    }

    onImageChanged(url) {
      this.messageService.setImageProject(url);
    }

    goToProjectList(){
      this.isSelected = "home";
      this.authService.projectshowed.next(null);
      this.authService.requestSelectStep(4);
      this.router.navigate(['/']);
    }

    ngAfterViewInit(): void {
        this.authService.endLoading.subscribe((term) =>{ 
            if(term == "1"){
                console.log("is connected")
                this.authService.getGlobalNotification().subscribe(res => {
                  this.allNotif = res['hydra:member']['all'];
                })
                this.authService.getUserInvitation(0, 10).subscribe(res => {
                  this.inviteBadge = res['hydra:totalItems'];
                  this.loadContact();
                });
                setTimeout(()=>{
                    this.startLoad = false;
                    this.userData = JSON.parse(localStorage.getItem('currentUser'));
                }, 500);
            }
          });
          this.authService.mode$.subscribe(mode => {
            this.mode = mode;
          });
    }

    ngOnInit() {
        this.idonglet = uuidv4();
        this.messageService.setOngletId(this.idonglet);
        this.hideNav = localStorage.getItem('hideNav') && localStorage.getItem('hideNav') !== "0" ? 1 : 0;
        this.isHamburguer = this.hideNav == 0 ? true : false;
        if(localStorage.getItem('currentUser')){
          this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id'];
          this.userData = JSON.parse(localStorage.getItem('currentUser'));
          this.userEmail = this.userData['email'];
          if(this.userData['roles'].includes("ROLE_MANAGER")){
              this.userManager = true;
          }
          this.getCurrentCompany();
        }
        
        if(window.location.href.endsWith("/dashboard")  || window.location.href.endsWith("/dashboardinst")){
          this.isSelected = "dashboard";
        } else if(window.location.href.endsWith("homes")){
          this.isSelected = "homes";
        } else if(window.location.href.endsWith("/dashboardsuivi")){
          this.isSelected = "suivi";
        } else if(window.location.href.endsWith("control")){
          this.isSelected = "control";
        }
        this.authService.initHeader.subscribe((term) =>{ 
          if(term){
            this.isSelected = term;
          }
        });
      this.messageService.obcompanyloaded.subscribe(res => {
        this.getCurrentCompany();
      })
      this.authService.getGlobalNotification().subscribe(res => {
        this.allNotif = res['hydra:member']['all'];
        //console.log("allNotif : "+this.allNotif);
      })
      this.authService.obnotifupdated.subscribe((res) =>{
        this.authService.getGlobalNotification().subscribe(res => {
          this.allNotif = res['hydra:member']['all'];
          //console.log("allNotif : "+this.allNotif);
        })
      });
        this.authService.getUserInvitation(0, 10).subscribe(res => {
          this.inviteBadge = res['hydra:totalItems'];
        });
        this.authService.obInviteBadge.subscribe((res) => {
          //console.log("invv "+res['hydra:totalItems'])
            this.inviteBadge = res['hydra:totalItems'];
          });
          this.authService.obreceiveInvitation.subscribe((idMessage) =>{ 
            //console.log("Iinvitation meme compte ")
            if(this.inviteBadge > 0) this.inviteBadge = this.inviteBadge -  1;
          });
        this.messageService.getTranslate()
            .subscribe(
                (data) => {
                    this.lang = data;
                }
            )
        /*if(localStorage.getItem('currentUser')){
            this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id'];
            this.userData = JSON.parse(localStorage.getItem('currentUser'));
            this.userEmail = this.userData['email'];
            if(this.userData['roles'].includes("ROLE_MANAGER")){
                this.userManager = true;
              }
        }*/
        
        this.authService.obconnect.subscribe((idMessage) =>{ 
            this.authService.getUserInvitation(0, 10).subscribe(res => {
              this.inviteBadge = res['hydra:totalItems'];
              this.loadContact();
              if(localStorage.getItem('currentUser')){
                this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id'];
                this.userData = JSON.parse(localStorage.getItem('currentUser'));
                this.userEmail = this.userData['email'];
                if(this.userData['roles'].includes("ROLE_MANAGER")){
                    this.userManager = true;
                  }
            }
            });
            //console.log("connecteddd");
            this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id'];
            this.userData = JSON.parse(localStorage.getItem('currentUser'));
        });

        this.authService.photoHeader.subscribe((term) =>{ 
          if(term){
            //console.log("ress "+term)
            this.userData.imageUrl = term;
            this.getAvatarlUrl(term);
          }
          //console.log('dans le smarnumber idmessage ==> '+idMessage);
        });

        
        this.authService.photoCompHeader.subscribe((term) =>{ 
          if(term){
            //console.log("ress "+term)
            this.userData.comImage = term;
            this.getCompanyUrl(term);
          }
          //console.log('dans le smarnumber idmessage ==> '+idMessage);
        });

        this.authService.obUpdateProfile.subscribe((res) => {
          console.log("image updated header")
          if(res === 1){
            this.getCurrentUser();
          } 
        });

        this.authService.obUpdateCompany.subscribe((message) => {
          if(message){
            this.setCompanyImage(message);
          } 
        });

        this.authService.obUpdateCompname.subscribe((res) => {
          if(res){
              this.userData.comName = res;
              this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
              this.currentUser.comName = res;
              localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
          } 
        });

        this.authService.obInviteInstant.subscribe((res) => {
          if(res === 1){
            this.inviteBadge += 1;
          } else this.inviteBadge -= 1;
        });
        this.authService.endLoading.subscribe((term) =>{ 
            if(term == "1"){
                setTimeout(()=>{
                    this.startLoad = false;
                }, 500);
            }
          });
        
        
    }

    setCompanyImage(message = null){
      if(message){
        var logo  = message.res.logo;
        this.userData.comImage = logo;
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.currentUser.comImage = logo;
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
      }
     }

    getCurrentUser(){
      var iduser = JSON.parse(localStorage.getItem('currentUser')).id;
       this.authService.getInfoContact(iduser)
       .subscribe( dataContact => {
          this.userData.imageUrl = dataContact['imageUrl'];
          this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
          this.currentUser.imageUrl = dataContact['imageUrl'];
          localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
       }, (error) => {
           alert('une erreur est survenue getCurrentUser update profile image');
       });
   
     }

     getCurrentCompany(){
      var idcompany = JSON.parse(localStorage.getItem('currentUser')).compId;
       this.authService.getInfoCompany(idcompany)
       .subscribe( dataContact => {
          var logo  = dataContact['logo'];
          if(logo) {
            this.userData.comImage = logo;
            this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
            this.currentUser.comImage = logo;
            localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
          }
       }, (error) => {
           console.log('Uh-oh, an error occurred! : ' +JSON.stringify(error));
       });
   
     }

     checkImageExists(url: string): void {
      const img = new Image();
      img.crossOrigin = 'Anonymous';  // Si tu veux permettre CORS
      img.src = url;
    
      img.onerror = (error) => {
        console.log("Erreur lors du chargement de l'image header", error);
        this.getCurrentCompany();
      };
    }

    onImageError() {
    }

    getCompanyUrl(avatarLink) {
      if(!avatarLink) return '../../assets/img/default-avatar.png';
      return environment.server_url+"/media/project_img/" + avatarLink;
    }

    goToDashboard(){
      this.isSelected = "dashboard";
      this.authService.currentProjectId.next(null);
      this.authService.requestSelectStep(4);
      this.router.navigate(['/dashboard']);
    }

    goToDashboardSuivi(){
      this.isSelected = "suivi";
      this.authService.currentProjectId.next(null);
      this.authService.requestSelectStep(4);
      this.router.navigate(['/dashboardsuivi']);
    }

    goToHelp(){
      this.authService.selectProject.emit("help");
      this.authService.requestSelectStep(4);
    }

    goToPilotage(){
      this.isSelected = "control";
      this.authService.currentProjectId.next(null);
      this.authService.requestSelectStep(4);
      this.router.navigate(['/control']);
    }

    goToProcess(){
      this.isSelected = "process";
      this.authService.currentProjectId.next(null);
      this.router.navigate(['/process']);
    }

    changeLang() {
        this.translate.use(this.lang);
        this.messageService.setTranslate(this.lang);
    }
    useLanguage(language: string) {
        this.translate.use(language);
        this.messageService.setTranslate(language);
    }

    logout() {
        this.authService.logout();
    }

    selectProject(){
        this.authService.selectProject.emit("select");
    }

    changeModeProject(value: 'collaboratif' | 'cooperatif') {
      if(value == this.mode) return;
      this.mode = value;
      this.authService.changeModeProject.emit("change");
    }

    openParams(){
        this.authService.selectProject.emit("params");
        this.authService.requestSelectStep(4);
    }

    openEntreprise(){
      this.authService.selectProject.emit("entreprise");
      this.authService.requestSelectStep(4);
    }

    public openSidebar() {
        this.hideNav = this.hideNav == 0 ? 1 : 0;
        this.coreService.toggleSidebar.emit(this.hideNav);
        this.isHamburguer = !this.isHamburguer;
    }
    public openNavbarmobile() {
        this.isOpenMenu = !this.isOpenMenu;
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(DialogVideo, {
          width: '700px',
          height: '450px',
          data: {}
        });
    
        dialogRef.afterClosed().subscribe(result => {
          //console.log('The dialog was closed');
        });
    }

    getAvatarlUrl(avatarLink){
        return environment.server_url+avatarLink;
      }

    
      openProfilDialog() {
        this.dialog.closeAll();
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'contactpanel';
        dialogConfig.id = 'balchal718';
        dialogConfig.width = '550px';
        dialogConfig.autoFocus = false;
        dialogConfig.data = { name: this.name, profile: this.profile, commonRef: this.commonRef };
        //const dialogRef = this.dialog.open(ProfileComponent, dialogConfig);
        const dialogRef = this.dialog.open(ProfileComponent, {
          data: { name: this.name, profile: this.profile, commonRef: this.commonRef },
          panelClass: 'profileclass',
          backdropClass: 'custom-backdrop'
        });
    
        dialogRef.afterClosed().subscribe((result: any) => {
        });
    
      }

      showLanguage(){
        this.authService.selectProject.emit("langue");
      }

      showInvitation() {
        this.authService.selectProject.emit("invitation");
        this.authService.requestSelectStep(4);
      }

      openDialogContacts() {
        this.dialog.closeAll();
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'contactpanel';
        dialogConfig.id = 'balchal717';
        dialogConfig.width = '550px';
        dialogConfig.autoFocus = false;
        dialogConfig.data = { name: this.name, profile: this.profile, commonRef: this.commonRef };
        const dialogRef = this.dialog.open(DashboardDialogComponent, dialogConfig);
    
        dialogRef.afterClosed().subscribe((result: any) => {
          if (result) {
            this.profile = result;
            this.router.navigate(['/profile/' + result]);
          }
        });
    
      }
    
}
